// ag-grid-react v30.0.4
import React from 'react';
export const BeansContext = React.createContext({});
